const _ = "_columns_10k0l_29", l = "_column_10k0l_29", s = {
  columns: _,
  "align-items-center": "_align-items-center_10k0l_36",
  "align-items-flex-start": "_align-items-flex-start_10k0l_39",
  "align-items-flex-end": "_align-items-flex-end_10k0l_42",
  "reverse-on-mobile": "_reverse-on-mobile_10k0l_57",
  column: l,
  "gap-0": "_gap-0_10k0l_68",
  "gap-1": "_gap-1_10k0l_71",
  "gap-2": "_gap-2_10k0l_74",
  "gap-3": "_gap-3_10k0l_77",
  "gap-4": "_gap-4_10k0l_80",
  "gap-5": "_gap-5_10k0l_83",
  "gap-6": "_gap-6_10k0l_86",
  "gap-7": "_gap-7_10k0l_89",
  "gap-8": "_gap-8_10k0l_92",
  "gap-9": "_gap-9_10k0l_95",
  "gap-10": "_gap-10_10k0l_98",
  "gap-11": "_gap-11_10k0l_101",
  "gap-12": "_gap-12_10k0l_104",
  "gap-14": "_gap-14_10k0l_107",
  "gap-16": "_gap-16_10k0l_110",
  "gap-18": "_gap-18_10k0l_113",
  "gap-20": "_gap-20_10k0l_116",
  "gap-24": "_gap-24_10k0l_119",
  "gap-28": "_gap-28_10k0l_122",
  "gap-32": "_gap-32_10k0l_125",
  "gap-36": "_gap-36_10k0l_128",
  "gap-40": "_gap-40_10k0l_131",
  "gap-44": "_gap-44_10k0l_134",
  "gap-48": "_gap-48_10k0l_137",
  "gap-52": "_gap-52_10k0l_140",
  "gap-56": "_gap-56_10k0l_143",
  "gap-60": "_gap-60_10k0l_146",
  "gap-64": "_gap-64_10k0l_149",
  "gap-72": "_gap-72_10k0l_152",
  "gap-80": "_gap-80_10k0l_155",
  "gap-96": "_gap-96_10k0l_158",
  "hidden-content-on-mobile": "_hidden-content-on-mobile_10k0l_161",
  "is-1": "_is-1_10k0l_180",
  "is-2": "_is-2_10k0l_184",
  "is-3": "_is-3_10k0l_188",
  "is-4": "_is-4_10k0l_192",
  "is-5": "_is-5_10k0l_196",
  "is-6": "_is-6_10k0l_200",
  "is-7": "_is-7_10k0l_204",
  "is-8": "_is-8_10k0l_208",
  "is-9": "_is-9_10k0l_212",
  "is-10": "_is-10_10k0l_216",
  "is-11": "_is-11_10k0l_220",
  "is-12": "_is-12_10k0l_224",
  "is-offset-1": "_is-offset-1_10k0l_228",
  "is-offset-2": "_is-offset-2_10k0l_231",
  "is-offset-3": "_is-offset-3_10k0l_234",
  "is-offset-4": "_is-offset-4_10k0l_237",
  "is-offset-5": "_is-offset-5_10k0l_240",
  "is-offset-6": "_is-offset-6_10k0l_243",
  "is-offset-7": "_is-offset-7_10k0l_246",
  "is-offset-8": "_is-offset-8_10k0l_249",
  "is-offset-9": "_is-offset-9_10k0l_252",
  "is-offset-10": "_is-offset-10_10k0l_255",
  "is-offset-11": "_is-offset-11_10k0l_258",
  "is-narrow": "_is-narrow_10k0l_261",
  "dialog-overlay-show": "_dialog-overlay-show_10k0l_1",
  "dialog-content-show": "_dialog-content-show_10k0l_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_10k0l_1"
};
export {
  s
};
